/* eslint-disable no-unused-expressions */
import React from "react";
import styles from "./UIFileType.module.scss";
import SvgXd from "../../../filePage/type/icon/SvgXd";
import SvgAi from "../../../filePage/type/icon/SvgAi";
import SvgDoc from "../../../filePage/type/icon/SvgDoc";
import SvgeExcel from "../../../filePage/type/icon/SvgeExcel";
import SvgPdf from "../../../filePage/type/icon/SvgPdf";
import SvgPowerPoint from "../../../filePage/type/icon/SvgPowerPoint";
import SvgSvg from "../../../filePage/type/icon/SvgSvg";
import SvgZip from "../../../filePage/type/icon/SvgZip";
import SvgOtherType from "../../../filePage/type/icon/SvgOtherType";
import SvgPsd from "../../../filePage/type/icon/SvgPsd";
import SvgText from "../../../filePage/type/icon/SvgText";
import {supportViewer} from "../../../filePage/properies.file";
import {useTranslation} from "react-i18next";
import {checkEmpty} from "src/service/util.service";

function UIFileType(props: any) {
  console.log("file : ",props.file);
  const { t } = useTranslation();
  // let sharedWithMeFolder = "Shared with me";
  let defualtSize = "32";
  let defaultBigSize = "40";
  let boxSizeWidth = "70px";
  let boxSizeHeight = "70px";
  
  if (props.fromUI === "detail") {
    defualtSize = "150";
    defaultBigSize = "150";
  }
  if (!checkEmpty(props.size)) {
    defualtSize = props.size;
  }
  if (props.fromMedia) {
    defaultBigSize = "100%";
    defualtSize = "100%";
  }
  if (props.recentbig) {
    defaultBigSize = "64";
    defualtSize = "80";
    boxSizeWidth = "100%";
    boxSizeHeight = "180px"
  }
  let disable = false;
  let uploadPreview = false;
  let type = props.type;
  if (!checkEmpty(props.type)) {
    type = props.type;
    uploadPreview = true;
  }

  if (supportViewer.svg.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgSvg
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgSvg>
      </div>
    );
  } else if (supportViewer.txt.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgText
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgText>
      </div>
    );
  } else if (supportViewer.bin.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorBinTypeActiveMove : styles.colorBinType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <i className="fas fa-trash"></i>
      </div>
    );
  } else if (["addicon"].indexOf(type) > -1) {
    return (
      <div style={props.color != null ? { color: props.color } : {}}>
        <i className="fas fa-plus"></i>
      </div>
    );
  } else if (supportViewer.xd.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgXd
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgXd>
      </div>
    );
  } else if (supportViewer.ai.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgAi
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgAi>
      </div>
    );
  } else if (supportViewer.doc.indexOf(type) > -1) {
    if (props.recentbig) {
      defaultBigSize = "50";
    }
    return (
      <div
        className={
          disable ? styles.colorDocTypeActiveMove : styles.colorDocType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgDoc
          width={defaultBigSize}
          height={defaultBigSize}
          activeMove={disable}
        ></SvgDoc>
      </div>
    );
  } else if (supportViewer.pdf.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgPdf
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgPdf>
      </div>
    );
  } else if (supportViewer.xls.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgeExcel
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgeExcel>
      </div>
    );
  } else if (supportViewer.ppt.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgPowerPoint
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgPowerPoint>
      </div>
    );
  } else if (supportViewer.zip.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgZip
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgZip>
      </div>
    );
  } else if (supportViewer.psd.indexOf(type) > -1) {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
        style={props.color != null ? { color: props.color } : {}}
      >
        <SvgPsd
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgPsd>
      </div>
    );
  } else {
    return (
      <div
        className={
          disable ? styles.colorOtherTypeActiveMove : styles.colorOtherType
        }
      >
        <SvgOtherType
          width={defualtSize}
          height={defualtSize}
          activeMove={disable}
        ></SvgOtherType>
      </div>
    );
  }
}

export default React.memo(UIFileType);
